import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { BgColorOptions, ColorOptions, UndefinedOption } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { PageComponentRangeSquaresImageComponent } from '../range-squares/range-squares-image.component';
export interface IPageComponentMobileRangeSquaresComponentData extends NICmsContentComponent.IData {
    elements: IRangeSquaresImage[];
    variant: 'squares_row' | 'large_square';
}
export interface IRangeSquaresImage {
    image?: string;
    title?: string;
    image_link?: string;
    font_color?: string;
    cta_link?: string;
    cta_copy?: string;
    pill_copy?: string;
    pill_text_color?: string;
    pill_bg_color?: string;
}
@Component({
    selector: 'page-component-mobile-range-squares',
    templateUrl: 'mobile-range-squares.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, PageComponentRangeSquaresImageComponent, GridModule]
})
@ICmsComponent<PageComponentMobileRangeSquaresComponent>({
    id: 'mobile-range-squares',
    name: 'Mobile Range Squares',
    tags: ['CLP', 'Content', 'Range'],
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'variant',
            type: NICmsContentField.EFieldType.choice,
            title: 'Variant',
            required: true,
            options: [UndefinedOption, { key: 'squares_row', title: 'Squares in a row' }, { key: 'large_square', title: 'Large square' }]
        },
        <NICmsContentField.IRepeaterField>{
            key: 'elements',
            title: 'CTA Elements',
            type: NICmsContentField.EFieldType.repeater,
            itemName: 'Item',
            defaultSize: 1,
            maxSize: data => (data.variant === 'squares_row' ? 2 : 1),
            fields: [
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'cta_copy',
                    title: 'CTA copy'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'cta_link',
                    title: 'CTA link'
                },
                {
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image'
                },
                {
                    type: NICmsContentField.EFieldType.text,
                    key: 'image_link',
                    title: 'Image link'
                },
                <NICmsContentField.IColorPickerField>{
                    key: 'font_color',
                    type: NICmsContentField.EFieldType.colorPicker,
                    title: 'Font Colour',
                    options: ColorOptions,
                    colorPreview: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'pill_copy',
                    title: 'Pill Copy',
                    default: 'Sale'
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'pill_text_color',
                    title: 'Pill Font Colour',
                    options: ColorOptions,
                    colorPreview: true,
                    default: 'col-w'
                },
                <NICmsContentField.IChoiceField>{
                    type: NICmsContentField.EFieldType.choice,
                    key: 'pill_bg_color',
                    title: 'Pill Background Colour',
                    options: BgColorOptions,
                    colorPreview: true,
                    default: 'bg-col-2'
                }
            ]
        }
    ]
})
export class PageComponentMobileRangeSquaresComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentMobileRangeSquaresComponentData;
}
